import type { Option } from '@pylot-data/hooks/product/use-product-ui'
import type {
    ConfigurableProductOptions,
    ConfigurableProductOptionsValues
} from '@pylot-data/pylotschema'
import { Maybe } from '@pylot-data/pylotschema'
import { getOptionType } from './getOptionType'

/**
 * Gets configurable product options
 * @param product
 * @returns
 */
export const getProductOptions = (
    configurableOptions: ConfigurableProductOptions[] | undefined
): Option[] => {
    if (!configurableOptions) return []

    const options =
        configurableOptions?.reduce<Option[]>((opts, opt) => {
            const { label: displayName, attribute_code: code, values } = opt
            const type = getOptionType(values?.[0])
            return [
                ...opts,
                {
                    displayName: displayName!,
                    code: code!,
                    values: values as Maybe<ConfigurableProductOptionsValues[]>,
                    type
                }
            ]
        }, [] as Option[]) ?? []
    return options
}
